import React, { useEffect, useRef, useState } from "react";
import { Typography } from "antd";

const CollapsibleTextBlock = ({
  text,
  lines = 3,
  expandLabel = "Expand",
  collapseLabel = "Collapse",
  style = {},
}) => {
  const containerRef = useRef(null);
  const measureRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);

  useEffect(() => {
    const measureOverflow = () => {
      const containerNode = containerRef.current;
      const measureNode = measureRef.current;

      if (!containerNode || !measureNode) {
        return;
      }

      measureNode.style.width = `${containerNode.clientWidth}px`;
      const computedStyle = window.getComputedStyle(measureNode);
      let lineHeight = parseFloat(computedStyle.lineHeight);

      if (Number.isNaN(lineHeight)) {
        const fontSize = parseFloat(computedStyle.fontSize) || 14;
        lineHeight = fontSize * 1.5;
      }

      setShowToggle(measureNode.scrollHeight > lineHeight * lines + 1);
    };

    measureOverflow();

    if (typeof ResizeObserver !== "undefined" && containerRef.current) {
      const resizeObserver = new ResizeObserver(measureOverflow);
      resizeObserver.observe(containerRef.current);

      return () => resizeObserver.disconnect();
    }

    window.addEventListener("resize", measureOverflow);
    return () => window.removeEventListener("resize", measureOverflow);
  }, [lines, text]);

  useEffect(() => {
    if (!showToggle && expanded) {
      setExpanded(false);
    }
  }, [expanded, showToggle]);

  if (text === null || text === undefined || text === "") {
    return <Typography.Text>-</Typography.Text>;
  }

  return (
    <div ref={containerRef} style={{ position: "relative", width: "100%" }}>
      <div
        style={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          overflow: "hidden",
          display: expanded ? "block" : "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: expanded ? "unset" : lines,
          ...style,
        }}
      >
        {text}
      </div>

      <div
        ref={measureRef}
        aria-hidden="true"
        style={{
          position: "absolute",
          visibility: "hidden",
          pointerEvents: "none",
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          overflow: "visible",
          height: "auto",
          zIndex: -1,
          ...style,
        }}
      >
        {text}
      </div>

      {showToggle && (
        <Typography.Link onClick={() => setExpanded((prev) => !prev)} style={{ padding: 0 }}>
          {expanded ? collapseLabel : expandLabel}
        </Typography.Link>
      )}
    </div>
  );
};

export default CollapsibleTextBlock;
